import React from 'react';
import { Img } from 'react-image';
import ImageLoader from './ImageLoader';
import CONFIG from '../../../config';

interface IImageProps {
  className?: string;
  imageName: string;
  altText: string;
  extension?: string;
  loaderOptions?: {
    width: string;
    height: string;
    position?: string;
  };
  useOnlyFallback?: boolean;
  useFullpath?: boolean;
}

const Image = ({
   className,
   imageName,
   altText,
   extension,
   loaderOptions,
   useOnlyFallback = false,
   useFullpath = false
 }: IImageProps) => {
  const originalSrc = !useFullpath ? require(`../../../assets/${imageName}${extension ? "." + extension : ""}`) : imageName;
  const fallBackSrc = !useFullpath ? `${CONFIG.assetDirectory}${imageName}${extension ? "." + extension : ""}` : imageName;
  const imgSrc = useOnlyFallback && process.env.NODE_ENV !== "development" ? fallBackSrc : [originalSrc, fallBackSrc];

  if (Object.keys(loaderOptions).length < 1) {
    <Img className={className} src={imgSrc} alt={altText} />;
  }

  return (
    <Img
      className={className}
      src={imgSrc}
      loader={<ImageLoader {...loaderOptions} />}
      alt={altText}
    />
  );
};

export default Image;
